import React from 'react';
import PropTypes from 'prop-types';

export default function BannerPromo({
  landscape,
  portrait,
  isThereAction,
  onClickBanner,
}) {
  return (
    <button
      className="banner-promo"
      onClick={isThereAction && onClickBanner}
      style={{ cursor: `${isThereAction ? 'pointer' : 'default'}` }}
    >
      {landscape && (
        <img className="hidden-xs" src={landscape} alt="" title="" />
      )}
      {portrait && (
        <img className="visible-xs" src={portrait} alt="" title="" />
      )}
    </button>
  );
}
BannerPromo.propTypes = {
  isThereAction: PropTypes.bool,
  onClickBanner: PropTypes.func,
  portrait: PropTypes.string,
  landscape: PropTypes.string,
};
